export const BUSINESS_HEADER_MENU_ITEMS = [
  { label: 'Home', href: '/' },
  { label: 'Sobre Nós', href: '#sobre' },
  { label: 'Tecnologias', href: '#tecnologias' },
  { label: 'Seja Nosso Parceiro', href: '#faca-parte' },
  { label: 'Dashboard', href: '/dashboard', className: 'btn-lojista' },
];

export const INSTITUTIONAL_HEADER_MENU_ITEMS = [
  { label: 'Home', href: '/' },
  { label: 'Sobre Nós', href: '/#sobre' },
  { label: 'Tecnologias', href: '/#tecnologias' },
  { label: 'Seja Nosso Parceiro', href: '/#faca-parte' },
  { label: 'Área do Lojista', href: '/dashboard', className: 'btn-lojista' },
];

export const CUSTOMER_HEADER_MENU_ITEMS = [
  { label: 'Home', href: '#hero' },
  { label: 'Produtos', href: '#produtos' },
  { label: 'Lojas Parceiras', href: '#lojas-parceiras' },
  { label: 'Baixar App', href: '#baixar-app' },
  { label: 'Área do Lojista', href: '/lojista', className: 'btn-lojista' },
];